import { z } from 'zod';
import { STUDY_PLAN_ISSUE_CODES } from '../lmd/study-plan';

export const STUDY_PLAN_STATUSES = ['missing', 'draft', 'validated'] as const;

export const StudyPlanIssueSchema = z.object({
  code: z.enum(STUDY_PLAN_ISSUE_CODES),
  semesterIndex: z.number().int().nullable(),
  levelCode: z.string().nullable(),
  unitCode: z.string().nullable(),
  courseId: z.uuid().nullable(),
  courseName: z.string().nullable(),
  credits: z.number().nullable(),
  target: z.number().int().nullable(),
});
export type StudyPlanIssueDto = z.infer<typeof StudyPlanIssueSchema>;

export const CoursePeriodSchema = z.object({
  courseId: z.uuid(),
  startsOn: z.iso.date(),
  endsOn: z.iso.date(),
});

export const StudyPlanSchema = z.object({
  status: z.enum(STUDY_PLAN_STATUSES),
  curriculumId: z.uuid().nullable(),
  periods: z.array(CoursePeriodSchema),
  issues: z.array(StudyPlanIssueSchema),
});
export type StudyPlanDto = z.infer<typeof StudyPlanSchema>;

export const StudyPlanQuerySchema = z.object({
  yearId: z.uuid(),
  programId: z.uuid(),
});

export const SaveCoursePeriodSchema = z
  .object({
    academicYearId: z.uuid(),
    courseId: z.uuid(),
    startsOn: z.iso.date('studyPlan.errors.date'),
    endsOn: z.iso.date('studyPlan.errors.date'),
  })
  .refine((v) => v.startsOn < v.endsOn, { path: ['endsOn'], message: 'studyPlan.errors.order' });
export type SaveCoursePeriod = z.infer<typeof SaveCoursePeriodSchema>;

export const ValidateStudyPlanSchema = z.object({
  yearId: z.uuid(),
  programId: z.uuid(),
});
